import React from "react";
import classnames from "classnames";
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { reportActions } from '../../store/reportStore';
import { bindActionCreators } from 'redux';
import { Translate } from "react-localize-redux";
import Legend from './legendComponent';
import AngleDownIcon from '../../img/icons/BBiconsRozbalit';
import BbCollapse from "./BbCollapse";

class Section extends React.Component {

    state = {
        isOpen: this.props.isOpen || false,
        isExpandedTouched: false
    };

    componentDidMount() {
        if (!isNullOrUndefined(this.props.onClick)) {
            //used for loading subsections that are defined on server
            this.props.onClick();
        }
        this.props.sectionId && this.props.attachSectionElement(this.props.sectionId, this.holder);
    }

    componentDidUpdate(prevProps) {
        if (this.props.isExpandAllActivated !== prevProps.isExpandAllActivated || this.props.isHideAllActivated !== prevProps.isHideAllActivated) {
            this.setState({ isExpandedTouched: false });
        }
        if (this.props.sectionToFocus && this.props.sectionToFocus === this.props.sectionId) {
            this.setState({ isExpandedTouched: true, isOpen: true });
            this.props.sectionFocused();
            this.props.scrollToElement(this.props.elements[this.props.sectionToFocus], true, 'smooth')
        }
    }

    render() {
        const expanded = this.props.resolveExpanded(this.state.isOpen, this.state.isExpandedTouched);
        return (
            <div data-level={this.props.removeDataLevel ? null : (this.props.level || 3)} className={classnames({ 'report-section': true, 'is-expanded': expanded })} style={this.props.style} ref={el => this.holder = el}>
                <div
                    className={classnames('header-wrap', {
                        'header-wrap-circle-icon': localStorage.locales_report_headers_style === 'round' || !this.props.isSection
                    })}
                    onClick={() => this.headerClick()}
                    style={this.props.headerStyle}
                >
                    <div className="header-body">
                        {this.props.headerBody ? <>{this.props.headerBody}</> : <div className="name">{this.props.name}</div>}
                        {this.renderIcon(expanded)}
                    </div>
                </div>
                <BbCollapse className='report-section-body' style={this.props.bodyStyle} tag="div" isOpen={expanded} name={this.props.name}>
                    <div>{this.props.children}</div>
                </BbCollapse>
            </div>
        )
    }
    renderIcon = (expanded) => {
        return (
            <div className="icon-wrap">
                {!isNullOrUndefined(this.props.legend && !isNullOrUndefined(this.props.legend.id) && !isNullOrUndefined(this.props.legend.text))
                    ? <span style={{ paddingRight: "0.75em" }}><Legend id={this.props.legend.id}>{this.props.legend.text}</Legend></span>
                    : null}
                <AngleDownIcon
                    style={{ transform: `scaleY(${expanded ? -1 : 1})`, transition: 'all .5s ease', width: '1.4em', height: '1.4em' }}
                    className={classnames('svg-standard-fill', { 'print-hidden': !expanded })} />
            </div>
        )
    }
    headerClick = () => {
        this.setState({ isExpandedTouched: true, isOpen: !this.props.resolveExpanded(this.state.isOpen, this.state.isExpandedTouched) })
        if (!isNullOrUndefined(this.props.onClick)) {
            //used for loading subsections that are defined on server
            this.props.onClick();
        }
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(Section))